module.exports = __webpack_public_path__ + "img/norway-blood-diseases-female.dd8fb4d3.png";